// Demo data for testing the learning sidebar feature
export const demoLearningSidebarData = {
  isEnabled: true,
  vocabulary: [
    {
      word: "important",
      definition: "Of great significance or value; likely to have a profound effect on success, survival, or well-being.",
      partOfSpeech: "adjective",
      difficulty: "intermediate" as const,
      frequency: 85
    },
    {
      word: "understand",
      definition: "To perceive the intended meaning of words, a language, or a speaker; to know how something works or why something happens.",
      partOfSpeech: "verb",
      difficulty: "beginner" as const,
      frequency: 92
    },
    {
      word: "development",
      definition: "The process of developing or being developed; growth, progress, or advancement.",
      partOfSpeech: "noun",
      difficulty: "intermediate" as const,
      frequency: 68
    },
    {
      word: "experience",
      definition: "Practical contact with and observation of facts or events; knowledge or skill acquired over time.",
      partOfSpeech: "noun",
      difficulty: "intermediate" as const,
      frequency: 79
    },
    {
      word: "knowledge",
      definition: "Facts, information, and skills acquired through experience or education; awareness or familiarity.",
      partOfSpeech: "noun",
      difficulty: "intermediate" as const,
      frequency: 73
    },
    {
      word: "significant",
      definition: "Sufficiently great or important to be worthy of attention; noteworthy.",
      partOfSpeech: "adjective",
      difficulty: "advanced" as const,
      frequency: 45
    },
    {
      word: "process",
      definition: "A series of actions or steps taken in order to achieve a particular end.",
      partOfSpeech: "noun",
      difficulty: "intermediate" as const,
      frequency: 81
    },
    {
      word: "create",
      definition: "To bring something into existence; to produce or bring about.",
      partOfSpeech: "verb",
      difficulty: "beginner" as const,
      frequency: 88
    },
    {
      word: "analysis",
      definition: "Detailed examination of the elements or structure of something.",
      partOfSpeech: "noun",
      difficulty: "advanced" as const,
      frequency: 52
    },
    {
      word: "effective",
      definition: "Successful in producing a desired or intended result.",
      partOfSpeech: "adjective",
      difficulty: "intermediate" as const,
      frequency: 67
    }
  ],
  phrases: [
    {
      phrase: "in order to",
      meaning: "For the purpose of; with the intention of achieving something.",
      usage: "We need to work together in order to succeed.",
      category: "common"
    },
    {
      phrase: "as well as",
      meaning: "In addition to; and also.",
      usage: "She speaks English as well as French.",
      category: "common"
    },
    {
      phrase: "make sure",
      meaning: "To take action so that something is certain to happen or be the case.",
      usage: "Please make sure you lock the door before leaving.",
      category: "common"
    },
    {
      phrase: "take place",
      meaning: "To happen or occur.",
      usage: "The meeting will take place at 3 PM.",
      category: "common"
    },
    {
      phrase: "point of view",
      meaning: "A particular attitude or way of considering a matter; perspective.",
      usage: "From my point of view, this is the best solution.",
      category: "common"
    },
    {
      phrase: "at the same time",
      meaning: "Simultaneously; at once.",
      usage: "She was happy and sad at the same time.",
      category: "common"
    }
  ]
};

// Export types for external use
export interface VocabularyEntry {
  word: string;
  definition: string;
  partOfSpeech?: string;
  difficulty?: 'beginner' | 'intermediate' | 'advanced';
  frequency?: number;
}

export interface PhraseEntry {
  phrase: string;
  meaning: string;
  usage?: string;
  category?: string;
}

export interface LearningSidebarData {
  vocabulary: VocabularyEntry[];
  phrases: PhraseEntry[];
  isEnabled?: boolean;
}